<template>
  <section class="container-full-5">

    <h2 class="secondary-font gap-4 mt-2 mb-6 text-center">Transaction</h2>

    <div v-if="loading" class="flex-center py-7">
      <p class="secondary-font text-grey-600">Chargement...</p>
    </div>

    <div v-else-if="transaction">
      <!-- Icône -->
      <div
        class="rounded-200 px-7 py-7 text-center"
        style="background-color: rgba(0, 185, 172, 0.08); width: 8.5rem; height: 8.5rem; margin: auto; display: flex; align-items: center; justify-content: center;"
      >
        <img src="/public/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" alt="" />
      </div>

      <!-- Libellé -->
      <h3 class="secondary-font text-center mt-6 mb-5">{{ transaction.libelle }}</h3>

      <!-- Montant -->
      <h1 class="secondary-font text-center" :class="transaction.type === 'credit' ? 'text-green' : ''">
        {{ transaction.type === 'credit' ? '+' : '-' }}{{ formatAmount(transaction.montant) }} F
      </h1>

      <!-- Détails -->
      <div class="s20 bg-grey-25 border-grey p-4 rounded-50 mt-5 px-7 py-7">

        <h6 class="s10 secondary-font font-normal text-right mb-4 px-5">Date d'opération</h6>
        <h6 class="s10 secondary-font mb-4 px-5">{{ formatDateDetail(transaction.date) }}</h6>

        <h6 class="s10 secondary-font font-normal text-right mb-4 px-5">Montant</h6>
        <h6 class="s10 secondary-font mb-4 px-5">{{ formatAmount(transaction.montant) }} F</h6>

        <h6 class="s10 secondary-font font-normal text-right mb-4 px-5">Catégorie</h6>
        <h6 class="s10 secondary-font mb-4 px-5">{{ categorieLabel(transaction.categorieSlug) }}</h6>

        <h6 class="s10 secondary-font font-normal text-right mb-4 px-5">Statut</h6>
        <h6 class="s10 secondary-font mb-4 px-5">
          <span class="tag-state success">Effectuée</span>
        </h6>

        <h6 class="s10 secondary-font font-normal text-right mb-4 px-5">Id de transaction</h6>
        <h6 class="s10 secondary-font mb-4 px-5">{{ transaction.reference }}</h6>

        <div class="clear-both h-1"></div>

        <button class="btn black mt-4 margin-auto" @click="shareTransaction">
          <img src="/public/icons/icon-share.svg" class="size-sm icon-white mr-2" alt="" />
          <span>Partager</span>
        </button>
      </div>
    </div>

    <div v-else class="text-center py-7">
      <p class="secondary-font text-grey-600">Transaction introuvable</p>
      <router-link to="/front/wallet" class="btn sm light mt-4">Retour au wallet</router-link>
    </div>

    <div class="clear-both h-60"></div>

  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import walletService, { type WalletTransaction } from '@/services/walletService'
import { formatAmount } from '@/utils/formatters'

const MOIS_NOMS = [
  '', 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
]

const CATEGORIE_LABELS: Record<string, string> = {
  supermarche: 'Supermarché',
  divertissement: 'Divertissement',
  market: 'Marketplace',
  sante: 'Santé',
  recharger: 'Recharge',
  retirer: 'Retrait',
  general: 'Général'
}

export default defineComponent({
  name: 'WalletTransactionDetail',
  setup() {
    const route = useRoute()
    const loading = ref(true)
    const transaction = ref<WalletTransaction | null>(null)

    function categorieLabel(slug: string): string {
      return CATEGORIE_LABELS[slug] || slug
    }

    function formatDateDetail(dateStr: string): string {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      if (isNaN(date.getTime())) return '-'
      const jour = date.getDate().toString().padStart(2, '0')
      const moisNom = MOIS_NOMS[date.getMonth() + 1]
      const annee = date.getFullYear()
      const heures = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${jour} ${moisNom} ${annee} ${heures}:${minutes}`
    }

    function shareTransaction() {
      if (!transaction.value) return
      const text = `Transaction ${transaction.value.reference}\n${transaction.value.libelle}\nMontant: ${transaction.value.montant} F\nDate: ${formatDateDetail(transaction.value.date)}`
      if (navigator.share) {
        navigator.share({ title: 'Transaction', text })
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
      }
    }

    async function loadTransaction() {
      loading.value = true
      try {
        const id = Number(route.params.id)
        if (!id) return
        const res = await walletService.getTransaction(id)
        if (res.data) {
          transaction.value = res.data
        }
      } catch (e) {
        // silencieux
      } finally {
        loading.value = false
      }
    }

    onMounted(() => {
      loadTransaction()
    })

    return {
      loading,
      transaction,
      formatAmount,
      categorieLabel,
      formatDateDetail,
      shareTransaction
    }
  }
})
</script>
